module.exports = __webpack_public_path__ + "img/g28107.55b12b64.png";